import React from "react";
import classnames from "classnames";

const PhoneSimulatorBody = ({children, className, ...props}) => {

    return (
        <>
            <div className={classnames('phone-simulator-body', className)} {...props}>
                {children}
            </div>
        </>
    )
}

export default PhoneSimulatorBody;
